<p-card
  class="dashcard mouse-pointer"
  [style]="{ '--dc-bg': _backgroundColor, '--dc-fg': fontColor, '--dc-accent': iconColor }"
  (click)="onCardClick($event)"
  role="button"
  tabindex="0"
  (keyup.enter)="onCardClick($event)"
  (keyup.space)="onCardClick($event)">
  <ng-template #header>
    <div class="dc-header">
      <div class="dc-icons">
        @if (!iconIsFile && icon) {
          <i class="dc-icon" [class]="icon" [style.backgroundColor]="iconBackgroundColor"></i>
        }
        @if (!iconIsFile && icon2) {
          <i class="dc-icon dc-icon--secondary" [class]="icon2" [style.backgroundColor]="iconBackgroundColor"></i>
        }
        @if (iconIsFile && icon) {
          <img class="p-2 dc-icon" [src]="icon" [alt]="title" [style.backgroundColor]="iconBackgroundColor" />
        }
        @if (iconIsFile && icon2) {
          <img class="p-2 dc-icon dc-icon--secondary" [src]="icon2" [alt]="title" [style.backgroundColor]="iconBackgroundColor" />
        }
      </div>

      @if (menuButton) {
        <button
          pButton
          type="button"
          class="p-button-text p-button-rounded dc-menu"
          icon="fas fa-ellipsis-v"
          (click)="$event.stopPropagation(); menu.toggle($event)"
          aria-label="Kartenmenü öffnen"></button>
        <p-menu #menu [popup]=true [model]="menuItems"></p-menu>
      }
    </div>
  </ng-template>

  <ng-template #title>
    {{ this.title }}
  </ng-template>

  @if (additionalText) {
    <p class="dc-info" [innerHTML]="additionalText"></p>
  }

  @if (hasFooter()) {
    <ng-container footer>
      <div class="dc-footer">
        <ng-content select="[card-footer]"></ng-content>
      </div>
    </ng-container>
  }
</p-card>
